import { OpenTalkApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useUpdate() {
  return useAuthMutation(OpenTalkApi.patch);
}

export default useUpdate;
